var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-pond',{ref:"pond",attrs:{"name":"image","label-idle":_vm.labelIdle,"accepted-file-types":"image/jpeg, image/png","server":_vm.filePondServer}})}
var staticRenderFns = []

export { render, staticRenderFns }